import React from "react";
import { Helmet } from "react-helmet-async";
import SEO from "../components/SEO";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Footer from "../components/Footer";
import ContactBanner from "../components/ContactBanner";
import TyresSection from "../components/TyresSection";
import Gallery from "../components/Gallery";
import ContactSection from "../components/ContactSection";
import MobileGarageInfo from "../components/MobileGarageInfo";

const Home = () => {
  const canonical = "https://carforensic.uk/";

  
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you offer mobile mechanic services across Kent?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Car Forensics LTD provides mobile garage services across Kent, including Maidstone, Gillingham, Sevenoaks and Sittingbourne."
        }
      },
      {
        "@type": "Question",
        "name": "What services do you provide?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We provide mobile auto repair, vehicle diagnostics, car servicing, ECU services, programming, tyres and recovery support. Contact us for availability and a quote."
        }
      },
      {
        "@type": "Question",
        "name": "How quickly can you attend a call-out?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We aim to respond as quickly as possible depending on your location and availability. Call +44 7501 911970 for same-day support where possible."
        }
      },
      {
        "@type": "Question",
        "name": "Do you cover Maidstone, Gillingham, Sevenoaks and Sittingbourne?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. We regularly cover Maidstone, Gillingham, Sevenoaks and Sittingbourne, as well as surrounding areas across Kent."
        }
      },
      {
        "@type": "Question",
        "name": "How do I book an appointment?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can call us on +44 7501 911970 or use the contact form on our website to request a quote or book a service."
        }
      }
    ]
  };

  
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": canonical
      }
    ]
  };

  return (
    <div>
      <SEO
        title="Car Forensics LTD"
        description="Car Forensics LTD provides mobile auto repair, diagnostics, servicing, ECU services, recovery and tyres across Kent. Covering Maidstone, Gillingham, Sevenoaks & Sittingbourne. Call +44 7501 911970 for fast same-day support."
        canonical={canonical}
      />

      
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <Hero />
      <Services />
      <MobileGarageInfo />
      <About />
      <ContactBanner />
      <TyresSection />
      <Gallery />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
